import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'reverse-trial.reverse-trial-popup.title',
		defaultMessage: 'Your 30-day Premium trial',
		description: 'Title for add payment details popup on premium plan',
	},
	explorePremiumFeaturesLink: {
		id: 'reverse-trial.reverse-trial-popup.explore-premium-features-link',
		defaultMessage: 'Explore Premium features',
		description:
			'Content for the link to explore premium features inside the premium trial popup which triggers when the user clicks the edition awareness pill. Optimal character count: 32.',
	},
	addPaymentDetailsLink: {
		id: 'reverse-trial.reverse-trial-popup.add-payment-details-link',
		defaultMessage: 'Add payment details to stay on Premium',
		description:
			'Content for the link to add payment details to stay on Premium, inside the premium trial popup which triggers when the user clicks the edition awareness pill. Optimal character count: 32.',
	},
	endTrialAndChangePlansLink: {
		id: 'reverse-trial.reverse-trial-popup.end-trial-and-change-plans-link',
		defaultMessage: 'End trial and change plans',
		description:
			'Content for the link to End trial and change plans inside the premium trial popup which triggers when the user clicks the edition awareness pill. Optimal character count: 32.',
	},
	afterTrial: {
		id: 'reverse-trial.reverse-trial-popup.after-trial',
		defaultMessage: 'After your trial, we’ll downgrade you to Free.',
		description:
			'A small description of what happens when the users premium trial will end. Optimal character count: 50',
	},
});
